var _title, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    fill: "#d50b0b",
    strokeDashoffset: "",
    fillRule: "evenodd",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_4",
    d: "M34.69092193209796,29.327786890548012 L30.273248685565363,21.67812612326035 C28.941398545862086,19.37223632914769 26.76296412069302,15.597686503895037 25.431113980989068,13.291796709781085 L21.01344073445717,5.642135942493393 C19.680421279441752,3.3350768330672693 17.501986854272676,3.3350768330672693 16.170136714569416,5.642135942493393 L11.753632783348307,13.291796709781085 C10.421782643645013,15.597686503895037 8.242178903164458,19.37340564445986 6.910328763461212,21.67812612326035 L2.4938248322407333,29.327786890548012 C1.1619746925374916,31.63601531528501 2.251776562777085,33.52212091259915 4.915476842184308,33.52212091259915 L32.266931291530796,33.52212091259915 C34.93297020156031,33.52212091259915 36.021602756489756,31.63601531528501 34.69092193209796,29.327786890548012 zM19.85347994553135,30.512303301013386 L17.233044332647196,30.512303301013386 L17.233044332647196,27.997106066157578 L19.85347994553135,27.997106066157578 L19.85347994553135,30.512303301013386 zM19.72719389189858,26.143741297561874 L17.361669016902912,26.143741297561874 L17.12663663930874,15.381363171283095 L19.94117859388829,15.381363171283095 L19.72719389189858,26.143741297561874 z",
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: "",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    strokeDashoffset: "",
    fillRule: "evenodd",
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    id: "svg_6",
    d: "M6.714868954729888,30.681801065019968 L18.619630973684067,8.84846797922672 L30.524392992638226,30.681801065019968 L6.714868954729888,30.681801065019968 z",
    style: {
      color: "rgb(0, 0, 0)"
    },
    className: "",
    fillOpacity: 1
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.729068160071982,12.658253628706932 C19.601195751354112,12.658253628706932 20.308236256256713,13.365268525478244 20.308236256256713,14.237404652804138 V23.71249859035015 C20.308236256256713,24.58462618163228 19.601195751354112,25.29166668653488 18.729068160071982,25.29166668653488 C17.856940568789852,25.29166668653488 17.14990006388725,24.58462618163228 17.14990006388725,23.71249859035015 V14.237404652804138 C17.14990006388725,13.365268525478244 17.856940568789852,12.658253628706932 18.729068160071982,12.658253628706932 z",
    fill: "#d50b0b",
    id: "svg_2",
    className: "",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.14989980600303,27.567252541872353 C17.15085473168876,26.680300202684734 17.87060826444833,25.962022464166733 18.75756060363595,25.96289057842649 L18.80461239651446,25.962977389852462 C19.691651547128053,25.963932315538187 20.40992928564605,26.683685848297763 20.408974359960325,27.570638187485383 C20.408019434274603,28.45767733809898 19.68826590151503,29.17595507661698 18.801313562327405,29.175000150931254 L18.7542617694489,29.174913339505277 C17.8672226188353,29.174045225245525 17.14894488031731,28.454204881059972 17.14989980600303,27.567252541872353 z",
    fill: "#d50b0b",
    id: "svg_3",
    className: "",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.f69d3ce43aae1a10487cefa57f03a242.svg";
export { ForwardRef as ReactComponent };